import axios from "axios";
import { responseStateMachine } from "../../utils/AxiosHelpers";
import { AXIOS_INSTANCE_CONFIG } from "../../utils/constants";
import { handleRequestHeaders } from "./headersManager";

const unAuthenticatedSource = axios.CancelToken.source();

const unAuthenticatedinstance = axios.create(AXIOS_INSTANCE_CONFIG);

unAuthenticatedinstance.interceptors.request.use(
    (request) => {
        return handleRequestHeaders(request, true);
    },
    (error) => {
        Promise.reject(error);
    }
);

unAuthenticatedinstance.interceptors.response.use(
    (response) => {
        return responseStateMachine(response);
    },
    (error) => {
        if (error.status !== 401) {
            return Promise.reject(error);
        }
        // axios.interceptors.response.eject(interceptor);
        // return refreshToken();
    }
);

export { unAuthenticatedinstance, unAuthenticatedSource };
